import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {CategoryMultiSelectSearchControlComponent} from "./category/controls/category-multi-select-search-control.component";
import {CategoryExcludeSubSearchControlComponent} from "./category/controls/category-exclude-sub-search-control.component";
import {ProductLineMultiSelectSearchControlComponent} from "./product-line/controls/product-line-multi-select-search-control.component";
import {CategorySingleSelectEditControlComponent} from "./category/controls/category-single-select-edit-control.component";
import {ExtraSingleSelectEditControlComponent} from "./extras/controls/extra-single-select-edit-control.component";
import {FrameworkModule} from "../framework/framework.module";
import {PricingSharedModule} from "../pricing/pricing.shared.module";
import {StockSharedModule} from "../stock/stock.shared.module";
import {MetaTagSingleSelectEditControlComponent} from "./meta-tag/controls/meta-tag-single-select-edit-control.component";
import {ProductContainerSingleSelectEditControlComponent} from "./product-container/controls/product-container-single-select-edit-control.component";
import {ProductLineSingleSelectEditControlComponent} from "./product-line/controls/product-line-single-select-edit-control.component";
import {SellableSingleSelectEditControlComponent} from "./sellable/controls/sellable-single-select-edit-control.component";
import {SellableEditLinkColumnComponent} from "./sellable/controls/sellable-edit-link-column.component";
import {CustomObjectSharedModule} from "../custom-objects/custom-object.shared.module";
import {SellableReportSelectionControlComponent} from "./sellable/controls/sellable-report-selection-control.component";
import {ExtraSingleSelectColumnComponent} from "./extras/controls/extra-single-select-column.component";
import {MetaTagMultiSelectEditControlComponent} from "./meta-tag/controls/meta-tag-multi-select-edit-control.component";
import {SellableMultiSelectSearchControlComponent} from "./sellable/controls/sellable-multi-select-search-control.component";
import {ProductBarcodeReportSelectionControlComponent} from "./product-barcode/controls/product-barcode-report-selection-control.component";
import {ProductBarcodeSingleSelectEditControlComponent} from "./product-barcode/controls/product-barcode-single-select-edit-control.component";
import {SellableSizeSingleSelectEditControlComponent} from "./sellable-size/controls/sellable-size-single-select-edit-control.component";
import {SizeGroupSingleSelectEditControlComponent} from "./size-group/controls/size-group-single-select-edit-control.component";
import {MetaTagValuesSingleSelectEditControlComponent} from "./meta-tag/controls/meta-tag-values-single-select-edit-control.component";
import {SizeGroupValuesSingleSelectEditControlComponent} from "./size-group/controls/size-group-values-single-select-edit-control.component";
import {MetaTagMultiSelectColumnComponent} from "./meta-tag/controls/meta-tag-multi-select-column.component";
import {SizeGroupSingleSelectColumnComponent} from "./size-group/controls/size-group-single-select-column.component";
import {ExtraMultiSelectEditControlComponent} from "./extras/controls/extra-multi-select-edit-control.component";
import {ExtraMultiSelectColumnComponent} from "./extras/controls/extra-multi-select-column.component";
import {CategorySingleSelectColumnComponent} from "./category/controls/category-single-select-column.component";
import {DietaryIndicatorMultiSelectEditControlComponent} from "./dietary-indicator/controls/dietary-indicator-multi-select-edit-control.component";
import {DietaryIndicatorMultiSelectColumnComponent} from "./dietary-indicator/controls/dietary-indicator-multi-select-column.component";
import {ExtraMultiSelectSearchControlComponent} from "./extras/controls/extra-multi-select-search-control.component";
import {PlgMultiSelectSearchControlComponent} from "./plg/controls/plg-multi-select-search-control.component";
import {
    CategoryMultiSelectEditControlComponent
} from "./category/controls/category-multi-select-edit-control.component";

@NgModule({
    imports: [
        SharedModule,
        FrameworkModule,
        CustomObjectSharedModule,
        PricingSharedModule,
        StockSharedModule
    ],
    declarations: [
        CategoryMultiSelectSearchControlComponent,
        CategoryMultiSelectEditControlComponent,
        CategorySingleSelectEditControlComponent,
        CategoryExcludeSubSearchControlComponent,
        CategorySingleSelectColumnComponent,
        ProductLineMultiSelectSearchControlComponent,
        ExtraSingleSelectEditControlComponent,
        ExtraMultiSelectEditControlComponent,
        ExtraMultiSelectSearchControlComponent,
        ProductBarcodeReportSelectionControlComponent,
        ProductBarcodeSingleSelectEditControlComponent,
        ExtraSingleSelectColumnComponent,
        ExtraMultiSelectColumnComponent,
        MetaTagSingleSelectEditControlComponent,
        MetaTagMultiSelectEditControlComponent,
        MetaTagMultiSelectColumnComponent,
        MetaTagValuesSingleSelectEditControlComponent,
        PlgMultiSelectSearchControlComponent,
        ProductContainerSingleSelectEditControlComponent,
        ProductLineSingleSelectEditControlComponent,
        SellableSingleSelectEditControlComponent,
        SellableMultiSelectSearchControlComponent,
        SellableEditLinkColumnComponent,
        SellableReportSelectionControlComponent,
        SellableSizeSingleSelectEditControlComponent,
        SizeGroupSingleSelectColumnComponent,
        SizeGroupSingleSelectEditControlComponent,
        SizeGroupValuesSingleSelectEditControlComponent,
        DietaryIndicatorMultiSelectEditControlComponent,
        DietaryIndicatorMultiSelectColumnComponent
    ],
    exports: [
        CategoryMultiSelectSearchControlComponent,
        CategoryMultiSelectEditControlComponent,
        CategorySingleSelectEditControlComponent,
        CategoryExcludeSubSearchControlComponent,
        CategorySingleSelectColumnComponent,
        ProductLineMultiSelectSearchControlComponent,
        ExtraSingleSelectEditControlComponent,
        ExtraMultiSelectEditControlComponent,
        ExtraMultiSelectSearchControlComponent,
        ProductBarcodeReportSelectionControlComponent,
        ProductBarcodeSingleSelectEditControlComponent,
        ExtraSingleSelectColumnComponent,
        ExtraMultiSelectColumnComponent,
        MetaTagSingleSelectEditControlComponent,
        MetaTagMultiSelectEditControlComponent,
        MetaTagMultiSelectColumnComponent,
        MetaTagValuesSingleSelectEditControlComponent,
        PlgMultiSelectSearchControlComponent,
        ProductContainerSingleSelectEditControlComponent,
        ProductLineSingleSelectEditControlComponent,
        SellableSingleSelectEditControlComponent,
        SellableMultiSelectSearchControlComponent,
        SellableEditLinkColumnComponent,
        SellableReportSelectionControlComponent,
        SellableSizeSingleSelectEditControlComponent,
        SizeGroupSingleSelectColumnComponent,
        SizeGroupSingleSelectEditControlComponent,
        SizeGroupValuesSingleSelectEditControlComponent,
        DietaryIndicatorMultiSelectEditControlComponent,
        DietaryIndicatorMultiSelectColumnComponent
    ]
})
export class CatalogueSharedModule {
}
